const resourse = {
  '居民喜好': { zhtw: '居民喜好', en: 'Gifts Guide', },
  '農作物': { zhtw: '農作物', en: 'Crops', },
  '物品': { zhtw: '物品', en: 'Items', },
  '地圖': { zhtw: '地圖', en: 'Map', },
  '動物': { zhtw: '動物', en: 'Animals', },
  '待辦清單': { zhtw: '待辦清單', en: 'ToDo', },
  '果樹': { zhtw: '果樹', en: 'Tree', },
  '蔬菜': { zhtw: '蔬菜', en: 'Veg/Fru', },
  '花卉': { zhtw: '花卉', en: 'Flowers', },
  '春': { zhtw: '春', en: 'Spr', },
  '夏': { zhtw: '夏', en: 'Sum', },
  '秋': { zhtw: '秋', en: 'F', },
  '冬': { zhtw: '冬', en: 'W', },
  '全季節': { zhtw: '全季節', en: 'All', },
  '全品種': { zhtw: '全品種', en: 'All', },
  'image': { zhtw: '圖片', en: 'Image', },
  'name': { zhtw: '名稱', en: 'Name', },
  'category': { zhtw: '種類', en: 'Category', },
  'season': { zhtw: '季節', en: 'Season', },
  'variant': { zhtw: '變種', en: 'Variant', },
  'growthDays': { zhtw: '成長天數', en: 'Growth Days', },
  '咖啡豆': { zhtw: '咖啡豆', en: 'Coffee Bean', },
  '櫻桃': { zhtw: '櫻桃', en: 'Cherry', },
  '柳橙': { zhtw: '柳橙', en: 'Orange', },
  '酪梨': { zhtw: '酪梨', en: 'Avocado', },
  '巨大酪梨': { zhtw: '巨大酪梨', en: 'Giant Avocado', },
  '杏仁': { zhtw: '杏仁', en: 'Almond', },
  '檸檬': { zhtw: '檸檬', en: 'Lemon', },
  '椰子': { zhtw: '椰子', en: 'Coconut', },
  '香蕉': { zhtw: '香蕉', en: 'Banana', },
  '可可豆': { zhtw: '可可豆', en: 'Cacao', },
  '芒果': { zhtw: '芒果', en: 'Mango', },
  '桃子': { zhtw: '桃子', en: 'Peach', },
  '黃金桃子': { zhtw: '黃金桃子', en: 'Golden Peach', },
  '蘋果': { zhtw: '蘋果', en: 'Apple', },
  '黃金蘋果': { zhtw: '黃金蘋果', en: 'Golden Apple', },
  '葡萄': { zhtw: '葡萄', en: 'Grapes', },
  '橄欖': { zhtw: '橄欖', en: 'Olive', },
  '馬鈴薯': { zhtw: '馬鈴薯', en: 'Potato', },
  '星型馬鈴薯': { zhtw: '星型馬鈴薯', en: 'Star Potato', },
  '蕪菁': { zhtw: '蕪菁', en: 'Turnip', },
  '巨大蕪菁': { zhtw: '巨大蕪菁', en: 'Giant Turnip', },
  '小黃瓜': { zhtw: '小黃瓜', en: 'Cucumber', },
  '洋蔥': { zhtw: '洋蔥', en: 'Onion', },
  '草莓': { zhtw: '草莓', en: 'Strawberry', },
  '黃金草莓': { zhtw: '黃金草莓', en: 'Golden Strawberry', },
  '大蒜': { zhtw: '大蒜', en: 'Garlic', },
  '櫛瓜': { zhtw: '櫛瓜', en: 'Zucchini', },
  '南瓜': { zhtw: '南瓜', en: 'Pumpkin', },
  '玉蜀黍': { zhtw: '玉蜀黍', en: 'Corn', },
  '彩色玉蜀黍': { zhtw: '彩色玉蜀黍', en: 'Mosaic Corn', },
  '番茄': { zhtw: '番茄', en: 'Tomato', },
  '巨大番茄': { zhtw: '巨大番茄', en: 'Giant Tomato', },
  '甜椒': { zhtw: '甜椒', en: 'Pepper', },
  '茄子': { zhtw: '茄子', en: 'Eggplant', },
  '圓球茄子': { zhtw: '圓球茄子', en: 'Round Eggplant', },
  '哈密瓜': { zhtw: '哈密瓜', en: 'Melon', },
  '珠寶哈密瓜': { zhtw: '珠寶哈密瓜', en: 'Jewel Melon', },
  '青椒': { zhtw: '青椒', en: 'Green Pepper', },
  '鳳梨': { zhtw: '鳳梨', en: 'Pineapple', },
  '西瓜': { zhtw: '西瓜', en: 'Watermelon', },
  '菠菜': { zhtw: '菠菜', en: 'Spinach', },
  '愛心菠菜': { zhtw: '愛心菠菜', en: 'Heart Spinach', },
  '維克多': { zhtw: '維克多', en: 'Victor', },
  '鎮長': { zhtw: '鎮長', en: 'Mayor', },
  '雅科波': { zhtw: '雅科波', en: 'Jacopo', },
  '橄欖鎮吉祥物/鎮長兒子': { zhtw: '橄欖鎮吉祥物/鎮長兒子', en: 'Son of Victor and Gloria', },
  '葛爾克': { zhtw: '葛爾克', en: 'Georg', },
  '船長': { zhtw: '船長', en: "Captain", },
  '賽門': { zhtw: '賽門', en: 'Simon'},
  '牛仔帽老爺爺': { zhtw: '牛仔帽老爺爺', en: 'Cowboy Grandpa'},
  '艾米里歐': { zhtw: '艾米里歐', en: 'Emilio'},
  '拌飯': { zhtw: '拌飯', en: 'Mixed Rice', },
  '白飯': { zhtw: '白飯', en: 'Cooked White Rice', },
  '氣派的路燈': { zhtw: '氣派的路燈', en: 'Splendid Street Lamp', },
  '豪華路燈': { zhtw: '豪華路燈', en: 'Gorgeous Street Lamp', },
  '木製長椅': { zhtw: '木製長椅', en: 'Wooden Bench', },
  '營火': { zhtw: '營火', en: 'Torch', },
  '鐵製長椅': { zhtw: '鐵製長椅', en: 'Iron Bench', },
  '巨大海鮮披薩': { zhtw: '巨大海鮮披薩', en: 'Giant Seafood Pizza', },
  '青醬義大利麵': { zhtw: '青醬義大利麵', en: 'Genovese Pasta', },
  '義大利漁夫麵': { zhtw: '義大利漁夫麵', en: 'Pescatore', },
  '蔬食披薩': { zhtw: '蔬食披薩', en: 'Vegetable Pizza', },
  '披薩': { zhtw: '披薩', en: 'Pizza', },
  '花香香精': { zhtw: '花香香精', en: 'Floral Essence', },
  '果香香精': { zhtw: '果香香精', en: 'Fruit Essence', },
  '百花香精': { zhtw: '百花香精', en: 'Bouquet Essence', },

  '花香香水': { zhtw: '花香香水', en: 'Floral Perfume', },
  '果香香水': { zhtw: '果香香水', en: 'Fruit Perfume', },
  '百花香水': { zhtw: '百花香水', en: 'Bouquet Perfume', },
  '魅惑香水': { zhtw: '魅惑香水', en: 'Charming Perfume', },

  '雞蛋': { zhtw: '雞蛋', en: 'Egg', },
  '頂級雞蛋': { zhtw: '頂級雞蛋', en: 'Egg +', },
  '烏骨雞蛋': { zhtw: '烏骨雞蛋', en: 'Silkie Egg', },
  '頂級烏骨雞蛋': { zhtw: '頂級烏骨雞蛋', en: 'Silkie Egg +', },
  '牛奶': { zhtw: '牛奶', en: 'Milk', },
  '頂級牛奶': { zhtw: '頂級牛奶', en: 'Milk +', },
  '水牛奶': { zhtw: '水牛奶', en: 'Buffalo Milk', },
  '頂級水牛奶': { zhtw: '頂級水牛奶', en: 'Buffalo Milk +', },
  '山羊奶': { zhtw: '山羊奶', en: 'Goat Milk', },
  '頂級山羊奶': { zhtw: '頂級山羊奶', en: 'Goat Milk +', },
  
  '雞蛋沙拉': { zhtw: '雞蛋沙拉', en: 'Egg Salad', },
  '馬鈴薯沙拉': { zhtw: '馬鈴薯沙拉', en: 'Potato Salad', },
  '荷包蛋': { zhtw: '荷包蛋', en: 'Fried Egg', },

  'page_neighbors_instruction': { zhtw: '點選物品後，畫面右邊會出現禮物按鈕，點它可以一覽要送出的配對。', en: 'After selecting an item, gift button will appear on the right side. Clicking it allows you to review what to give and to whom.', },
  'page_neighbors_non_marriage_candidate': { zhtw: '不可結婚居民', en: 'non marriage candidate', },
  'page_neighbors_marriage_candidate': { zhtw: '可結婚居民', en: 'marriage candidate', },
  'page_neighbors_search_bar_instruction': { zhtw: '可搜尋多個關鍵字，Ex：維克多 食材店 手錶', en: 'Allow multi-search, ex: Victor town hall Watch', },
  'page_neighbors_favorite': { zhtw: '最愛', en: 'Favorite', },
  'page_neighbors_loved': { zhtw: '很喜歡', en: 'Loved', },
  'page_neighbors_liked': { zhtw: '喜歡', en: 'Liked', },
  'page_crops_instruction': { zhtw: '點選作物後，畫面右邊會出現背包按鈕，點它可以一覽你現在需要的農作物。', en: 'After clicking on the crop, backpack button will appear on the right side. Clicking it allows you to review what crops you need.', },
  'page_crops_most_valuable_crop': { zhtw: '該季節最有價值的作物', en: 'Most valuable crop of the season', },
  'page_crops_search_bar_instruction': { zhtw: '可搜尋多個關鍵字，Ex：芒果 綠花椰菜', en: 'Allow multi-search, ex: onion Garlic', },
  'page_crops_no_trees_and_crops_in_winter': { zhtw: '冬天不能種果樹和農作物喔', en: "Can't plant trees and crops in winter", },
  'page_item_search_bar_instruction': { zhtw: '可搜尋多個關鍵字，Ex：橄欖結晶 菇類 雜貨店', en: 'Allow multi-search in Name, Category and Way. Ex: log Treasure', },
  '鎮公所': { zhtw: '鎮公所', en: 'Town Hall', },
  '動物店': { zhtw: '動物店', en: 'Animal Shop', },
  '香菇': { zhtw: '香菇', en: 'Shiitake Mushroom', },
  '鴻喜菇': { zhtw: '鴻喜菇', en: 'Shimeji Mushroom', },
  '杏鮑菇': { zhtw: '杏鮑菇', en: 'Trumpet Mushroom', },
  '粉紅珊瑚菇': { zhtw: '粉紅珊瑚菇', en: 'Coral Mushroom', },
  '洋菇': { zhtw: '洋菇', en: 'Common Mushroom', },
  '松茸': { zhtw: '松茸', en: 'Matsutake Mushroom', },
  '烹飪': { zhtw: '烹飪', en: 'Cooking', },
  '沙拉': { zhtw: '沙拉', en: 'Salad', },
  '其他': { zhtw: '其他', en: 'Other', },
  '湯': { zhtw: '湯', en: 'Soup', },
  '主餐': { zhtw: '主餐', en: 'Entrée', },
  '甜點': { zhtw: '甜點', en: 'Dessert', },
  '全品項': { zhtw: '全品項', en: 'All', },
  '今晚吃什麼': { zhtw: '今晚吃什麼', en: 'Today Dinner', },
  'ingredients': { zhtw: '材料', en: 'Ingredients', },
  '蔬菜類': { zhtw: '蔬菜類', en: 'Vegetable Group', },
  '山菜類': { zhtw: '山菜類', en: 'Wild Plant Group', },
  '馬鈴薯類': { zhtw: '馬鈴薯類', en: 'Potato Group', },
  '蘋果類': { zhtw: '蘋果類', en: 'Apple Group', },
  '桃子類': { zhtw: '桃子類', en: 'Peach Group', },
  '蔬菜沙拉': { zhtw: '蔬菜沙拉', en: 'Vegetable Salad', },
  '綜合沙拉': { zhtw: '綜合沙拉', en: 'Mixed Salad', },
  '泰式涼拌冬粉沙拉': { zhtw: '泰式涼拌冬粉沙拉', en: 'Yum Woon Sen', },
  '烏賊類': { zhtw: '烏賊類', en: 'Squid Group', },
  '哈密瓜類': { zhtw: '哈密瓜類', en: 'Melon Group', },
  '洋蔥拌炒馬鈴薯': { zhtw: '洋蔥拌炒馬鈴薯', en: 'Lyonnaise Potatoes', },
  '酪梨類': { zhtw: '酪梨類', en: 'Avocado Group', },
  '蛋類': { zhtw: '蛋類', en: 'Egg Group', },
  '櫻桃蘿蔔': { zhtw: '櫻桃蘿蔔', en: 'Radish', },
  '水果沙拉': { zhtw: '水果沙拉', en: 'Fruit Salad', },
  '水果類': { zhtw: '水果類', en: 'Fruit Group', },
  '醃漬小魚': { zhtw: '醃漬小魚', en: 'Small Fish Marinade', },
  '小型魚類': { zhtw: '小型魚類', en: 'Small Fish Group', },
  '豆子沙拉': { zhtw: '豆子沙拉', en: 'Bean Salad', },
  '蕪菁類': { zhtw: '蕪菁類', en: 'Turnip Group', },
  '豆子': { zhtw: '豆子', en: 'Beans', },
  '番茄類': { zhtw: '番茄類', en: 'Tomato Group', },
  '酸黃瓜': { zhtw: '酸黃瓜', en: 'Pickles', },
  '白蘿蔔': { zhtw: '白蘿蔔', en: 'Daikon Radish', },
  '分岔白蘿蔔': { zhtw: '分岔白蘿蔔', en: 'Fork-root Daikon', },
  '白蘿蔔類': { zhtw: '白蘿蔔類', en: 'Daikon Radish Group', },
  '醃漬香菇': { zhtw: '醃漬香菇', en: 'Mushroom Marinade', },
  '香料咖哩炒秋葵': { zhtw: '香料咖哩炒秋葵', en: 'Bhindi Masala', },
  '秋葵': { zhtw: '秋葵', en: 'Okra', },
  '日式炒牛蒡': { zhtw: '日式炒牛蒡', en: 'Kinpira Gobo', },
  '牛蒡': { zhtw: '牛蒡', en: 'Burdock', },
  '胡蘿蔔': { zhtw: '胡蘿蔔', en: 'Carrot', },
  '辣椒': { zhtw: '辣椒', en: 'Chili Pepper', },
  '義式番茄起司沙拉': { zhtw: '義式番茄起司沙拉', en: 'Caprese Salad', },
  '菠菜泥優格沙拉': { zhtw: '菠菜泥優格沙拉', en: 'Spinach Salad', },
  '菠菜類': { zhtw: '菠菜類', en: 'Spinach Group', },
  '芬蘭甜菜沙拉': { zhtw: '芬蘭甜菜沙拉', en: 'Rosolli', },
  '泡菜': { zhtw: '泡菜', en: 'Kimchi', },
  '白菜': { zhtw: '白菜', en: 'Napa Cabbage', },
  '黃金白菜': { zhtw: '黃金白菜', en: 'Golden Napa Cabbage', },
  '白菜類': { zhtw: '白菜類', en: 'Napa Cabbage Group', },
  '青江菜': { zhtw: '青江菜', en: 'Bok Choy', },
  '蚌殼湯': { zhtw: '蚌殼湯', en: 'Shellfish Soup', },
  '青蔥': { zhtw: '青蔥', en: 'Leek', },
  '巨大的青蔥': { zhtw: '巨大的青蔥', en: 'Giant Leek', },
  '青蔥類': { zhtw: '青蔥類', en: 'Leek Group', },
  '綜合蔬菜湯': { zhtw: '綜合蔬菜湯', en: 'Mixed Soup', },
  '黃色蔬菜濃湯': { zhtw: '黃色蔬菜濃湯', en: 'Yellow Potage', },
  '奶類': { zhtw: '奶類', en: 'Milk Group', },
  '綠色蔬菜濃湯': { zhtw: '綠色蔬菜濃湯', en: 'Green Potage', },
  '酸辣湯': { zhtw: '酸辣湯', en: 'Hot & Sour Soup', },
  '西班牙冷湯': { zhtw: '西班牙冷湯', en: 'Gazpacho', },
  '秋葵湯': { zhtw: '秋葵湯', en: 'Okra Soup', },
  '大型魚類': { zhtw: '大型魚類', en: 'Large Fish Group', },
  '蛤蜊巧達濃湯': { zhtw: '蛤蜊巧達濃湯', en: 'Clam Chowder', },
  '貝類': { zhtw: '貝類', en: 'Shellfish Group', },
  '拿波里水煮魚': { zhtw: '拿波里水煮魚', en: 'Acqua Pazza', },
  '螃蟹類': { zhtw: '螃蟹類', en: 'Crab Group', },
  '馬賽魚湯': { zhtw: '馬賽魚湯', en: 'Bouillabaisse', },
  '綠花椰菜': { zhtw: '綠花椰菜', en: 'Broccoli', },
  '泰式酸辣湯': { zhtw: '泰式酸辣湯', en: 'Tom Yum Goong', },
  '焗烤洋蔥湯': { zhtw: '焗烤洋蔥湯', en: 'Onion Soup', },
  '麵包類': { zhtw: '麵包類', en: 'Bread Group', },
  '韓式年糕湯': { zhtw: '韓式年糕湯', en: 'Tteokguk', },
  '西班牙香蒜湯': { zhtw: '西班牙香蒜湯', en: 'Sopa de Ajo', },
  '義式蔬菜湯': { zhtw: '義式蔬菜湯', en: 'Minestrone', },
  '高麗菜': { zhtw: '高麗菜', en: 'Cabbage', },
  '日式蔬菜豆腐湯': { zhtw: '日式蔬菜豆腐湯', en: 'Kenchin-jiru', },
  '龍宮湯': { zhtw: '龍宮湯', en: 'Oarfish Soup', },
  '櫻桃冷湯': { zhtw: '櫻桃冷湯', en: 'Sour Cherry Soup', },
  '法式燉菜湯': { zhtw: '法式燉菜湯', en: 'Pot-au-Feu', },
  '羅宋湯': { zhtw: '羅宋湯', en: 'Borscht', },
  '希臘檸檬湯': { zhtw: '希臘檸檬湯', en: 'Lemon Soup', },
  '烤魚': { zhtw: '烤魚', en: 'Grilled Fish', },
  '蔬菜三明治': { zhtw: '蔬菜三明治', en: 'Vegetable Sandwich', },
  '咖哩飯': { zhtw: '咖哩飯', en: 'Curry Rice', },
  '雞蛋三明治': { zhtw: '雞蛋三明治', en: 'Egg Sandwich', },
  '歐姆蛋': { zhtw: '歐姆蛋', en: 'Omelet', },
  '麻辣螯蝦': { zhtw: '麻辣螯蝦', en: 'Mala Crayfish', },
  '泰式炸蝦吐司': { zhtw: '泰式炸蝦吐司', en: 'Shrimp Toast', },
  '異國風味咖哩': { zhtw: '異國風味咖哩', en: 'Okra Curry', },
  '鯛魚生魚片': { zhtw: '鯛魚生魚片', en: 'Sea Bream Sashimi', },
  '中華拉麵': { zhtw: '中華拉麵', en: 'Chuka Soba', },
  '乾燒明蝦': { zhtw: '乾燒明蝦', en: 'Chili Shrimp', },
  '天婦羅': { zhtw: '天婦羅', en: 'Tempura', },
  '鰻魚飯': { zhtw: '鰻魚飯', en: 'Unaju', },
  '茄汁焗豆': { zhtw: '茄汁焗豆', en: 'Baked Beans', },
  '豆皮烏龍麵': { zhtw: '豆皮烏龍麵', en: 'Kitsune Udon', },
  '日式拿坡里義大利麵': { zhtw: '日式拿坡里義大利麵', en: 'Neapolitan Pasta', },
  '栗子飯': { zhtw: '栗子飯', en: 'Chestnut Rice', },
  '日式煮魚': { zhtw: '日式煮魚', en: 'Boiled Fish', },
  '普羅旺斯燉菜': { zhtw: '普羅旺斯燉菜', en: 'Ratatouille', },
  '西班牙烤大蔥': { zhtw: '西班牙烤大蔥', en: 'Calçots', },
  '海鮮蓋飯': { zhtw: '海鮮蓋飯', en: 'Sashimi Bowl', },
  '葡萄牙海鮮銅鍋料理': { zhtw: '葡萄牙海鮮銅鍋料理', en: 'Seafood Cataplana', },
  '日式炸浸蔬菜': { zhtw: '日式炸浸蔬菜', en: 'Brothy Fried Vegetables', },
  '果醬三明治': { zhtw: '果醬三明治', en: 'Jam Sandwich', },
  '日式燉菜': { zhtw: '日式燉菜', en: 'Boiled Vegetables', },
  '法式吐司': { zhtw: '法式吐司', en: 'French Toast', },
  '鮪魚三明治': { zhtw: '鮪魚三明治', en: 'Tuna Sandwich', },
  '法式煎蔬菜': { zhtw: '法式煎蔬菜', en: 'Vegetable Sauté', },
  '燉馬鈴薯': { zhtw: '燉馬鈴薯', en: 'Boiled Sweet Potatoes', },
  '白醬義大利麵': { zhtw: '白醬義大利麵', en: 'Cream Sauce Pasta', },
  '焗烤通心粉': { zhtw: '焗烤通心粉', en: 'Gratin', },
  '奶油培根蛋黃麵': { zhtw: '奶油培根蛋黃麵', en: 'Carbonara', },
  '西班牙風醃漬沙丁魚': { zhtw: '西班牙風醃漬沙丁魚', en: 'Boquerones en Vinagre', },
  '法式鹹派': { zhtw: '法式鹹派', en: 'Quiche', },
  '田園野菇派': { zhtw: '田園野菇派', en: 'Mushroom Pie', },
  '酥炸鮪魚塊': { zhtw: '酥炸鮪魚塊', en: 'Fried Tuna Cutlet', },
  '碗豆燉飯': { zhtw: '碗豆燉飯', en: 'Risi e Bisi', },
  '松茸炊飯': { zhtw: '松茸炊飯', en: 'Matsutake Rice', },
  '泰式咖哩蟹': { zhtw: '泰式咖哩蟹', en: 'Boo Paht Pong Karee', },
  '西班牙式鐵板煎菇': { zhtw: '西班牙式鐵板煎菇', en: 'Champiñones a la Plancha', },
  '蒜味辣椒義大利麵': { zhtw: '蒜味辣椒義大利麵', en: 'Peperoncino Pasta', },
  '奶油燉菜': { zhtw: '奶油燉菜', en: 'Stew', },
  '洋菇高麗菜捲': { zhtw: '洋菇高麗菜捲', en: 'Mushroom Cabbage Rolls', },
  '泰式酸辣鯰魚湯': { zhtw: '泰式酸辣鯰魚湯', en: 'Tom Yum Pla', },
  '烤大雀鱔': { zhtw: '烤大雀鱔', en: 'Grilled Gar', },
  '大碗海鮮抓飯': { zhtw: '大碗海鮮抓飯', en: 'Seafood Pilaf Platter', },
  '墨西哥玉米湯餅': { zhtw: '墨西哥玉米湯餅', en: 'Tortilla Soup', },
  '旗魚壽司': { zhtw: '旗魚壽司', en: 'Marlin Sushi', },
  '瑞士起司火鍋': { zhtw: '瑞士起司火鍋', en: 'Cheese Fondue', },
  '義式烤扁鱈': { zhtw: '義式烤扁鱈', en: 'Halibut al Cartoccio', },
  '泡菜鍋': { zhtw: '泡菜鍋', en: 'Kimchi Hot Pot', },
  '日式白湯鍋': { zhtw: '日式白湯鍋', en: 'Hot Pot', },
  '蕃薯': { zhtw: '蕃薯', en: 'Sweet Potato', },
  '巨大蕃薯': { zhtw: '巨大蕃薯', en: 'Giant Sweet Potato', },
  '玉蜀黍類': { zhtw: '玉蜀黍類', en: 'Corn Group', },
  '稻米': { zhtw: '稻米', en: 'Rice', },
  '蝦類': { zhtw: '蝦類', en: 'Shrimp Group', },
  '菇類': { zhtw: '菇類', en: 'Mushroom Group', },
  '茄子類': { zhtw: '茄子類', en: 'Eggplant Group', },
  '果醬類': { zhtw: '果醬類', en: 'Jam Group', },
  '中型魚類': { zhtw: '中型魚類', en: 'Medium Fish Group', },
  '蕃薯類': { zhtw: '蕃薯類', en: 'Sweet Potato Group', },
  '魚類': { zhtw: '魚類', en: 'Fish Group', },
  '艾草大福': { zhtw: '艾草大福', en: 'Mugwort Daifuku', },
  '糖漬水果': { zhtw: '糖漬水果', en: 'Fruit Compôte', },
  '紅豆麻糬湯': { zhtw: '紅豆麻糬湯', en: 'Oshiruko', },
  '草莓大福': { zhtw: '草莓大福', en: 'Strawberry Daifuku', },
  '栗子最中餅': { zhtw: '栗子最中餅', en: 'Chestnut Monaka', },
  '三種牡丹餅': { zhtw: '三種牡丹餅', en: 'Botamochi', },
  '布丁': { zhtw: '布丁', en: 'Pudding', },
  '美式鬆餅': { zhtw: '美式鬆餅', en: 'Pancakes', },
  '蜂蜜優格': { zhtw: '蜂蜜優格', en: 'Honey Yogurt', },
  '地瓜燒': { zhtw: '地瓜燒', en: 'Candied Sweet Potatoes', },
  '蒙布朗': { zhtw: '蒙布朗', en: 'Mont Blanc', },
  '黃豆粉烤年糕吐司': { zhtw: '黃豆粉烤年糕吐司', en: 'Injeolmi Toast', },
  '楓糖瑪芬蛋糕': { zhtw: '楓糖瑪芬蛋糕', en: 'Maple Muffin', },
  '烤蘋果': { zhtw: '烤蘋果', en: 'Baked Apple', },
  '咖啡布丁': { zhtw: '咖啡布丁', en: 'Coffee Pudding', },
  '餅乾': { zhtw: '餅乾', en: 'Cookies', },
  '草莓奶油蛋糕': { zhtw: '草莓奶油蛋糕', en: 'Shortcake', },
  '水果蛋糕': { zhtw: '水果蛋糕', en: 'Fruitcake', },
  '起司蛋糕': { zhtw: '起司蛋糕', en: 'Cheesecake', },
  '杏仁餅乾': { zhtw: '杏仁餅乾', en: 'Almond Cookies', },
  '堅果瑪芬蛋糕': { zhtw: '堅果瑪芬蛋糕', en: 'Nut Muffin', },
  '巧克力瑪芬蛋糕': { zhtw: '巧克力瑪芬蛋糕', en: 'Chocolate Muffin', },
  '蜂蜜布丁': { zhtw: '蜂蜜布丁', en: 'Honey Pudding', },
  '巧克力蛋糕': { zhtw: '巧克力蛋糕', en: 'Chocolate Cake', },
  '薩赫蛋糕': { zhtw: '薩赫蛋糕', en: 'Sachertorte', },
  '巧克力餅乾': { zhtw: '巧克力餅乾', en: 'Chocolate Cookies', },
  '提拉米蘇': { zhtw: '提拉米蘇', en: 'Tiramisu', },
  '布朗尼蛋糕': { zhtw: '布朗尼蛋糕', en: 'Brownies', },
  '黑森林蛋糕': { zhtw: '黑森林蛋糕', en: 'Black Forest Cake', },
  '拉明頓蛋糕': { zhtw: '拉明頓蛋糕', en: 'Lamington', },
  '芒果糯米飯': { zhtw: '芒果糯米飯', en: 'Khaoniao Mamuang', },
  '西班牙杏仁糕點': { zhtw: '西班牙杏仁糕點', en: 'Panellets', },
  '蜂蜜地瓜燒': { zhtw: '蜂蜜地瓜燒', en: 'Honeyed Sweet Potatoes', },
  '義式奶酪': { zhtw: '義式奶酪', en: 'Panna Cotta', },
  '茶': { zhtw: '茶', en: 'Tea', },
  '蔬菜汁': { zhtw: '蔬菜汁', en: 'Vegetable Juice', },
  '番茄汁': { zhtw: '番茄汁', en: 'Tomato Juice', },
  '香草茶': { zhtw: '香草茶', en: 'Herb Tea', },
  '麵包': { zhtw: '麵包', en: 'Bread', },
  '熱牛奶': { zhtw: '熱牛奶', en: 'Hot Milk', },
  '優酪乳': { zhtw: '優酪乳', en: 'Yogurt Drink', },
  '咖啡': { zhtw: '咖啡', en: 'Coffee', },
  '柳橙汁': { zhtw: '柳橙汁', en: 'Orange Juice', },
  '奶茶': { zhtw: '奶茶', en: 'Milk Tea', },
  '印度奶茶': { zhtw: '印度奶茶', en: 'Chai', },
  '草莓牛奶': { zhtw: '草莓牛奶', en: 'Strawberry Milk', },
  '蘋果汁': { zhtw: '蘋果汁', en: 'Apple Juice', },
  '可可亞': { zhtw: '可可亞', en: 'Cacao', },
  '洋蔥麵包': { zhtw: '洋蔥麵包', en: 'Onion Bread', },
  '椰子汁': { zhtw: '椰子汁', en: 'Coconut Juice', },
  '葡萄汁': { zhtw: '葡萄汁', en: 'Grape Juice', },
  '香蕉牛奶': { zhtw: '香蕉牛奶', en: 'Banana Milk', },
  '摩卡': { zhtw: '摩卡', en: 'Caffè Mocha', },
  '玉米麵包': { zhtw: '玉米麵包', en: 'Cornbread', },
  '蜂蜜拿鐵': { zhtw: '蜂蜜拿鐵', en: 'Honey Milk Latte', },
  '蜂蜜牛奶可可': { zhtw: '蜂蜜牛奶可可', en: 'Honey Milk Cacao', },
  '芒果汁': { zhtw: '芒果汁', en: 'Mango Juice', },
  '蜂蜜檸檬汁': { zhtw: '蜂蜜檸檬汁', en: 'Honey Lemon Juice', },
  '水果歐蕾': { zhtw: '水果歐蕾', en: 'Fruit au Lait', },
  '飯糰': { zhtw: '飯糰', en: 'Onigiri', },
  '鬱金香': { zhtw: '鬱金香', en: 'Tulip', },
  '粉蝶花': { zhtw: '粉蝶花', en: 'Nemophila', },
  '三色堇': { zhtw: '三色堇', en: 'Pansy', },
  '陸蓮花': { zhtw: '陸蓮花', en: 'Buttercup', },
  '黑色三色堇': { zhtw: '黑色三色堇', en: 'Black Pansy', },
  '扶桑花': { zhtw: '扶桑花', en: 'Hibiscus', },
  '矮牽牛': { zhtw: '矮牽牛', en: 'Petunia', },
  '萬壽菊': { zhtw: '萬壽菊', en: 'Marigold', },
  '向日葵': { zhtw: '向日葵', en: 'Sunflower', },
  '百合': { zhtw: '百合', en: 'Lily', },
  '玫瑰': { zhtw: '玫瑰', en: 'Rose', },
  '乒乓菊': { zhtw: '乒乓菊', en: 'Mum', },
  '鐵線蓮': { zhtw: '鐵線蓮', en: 'Clematis', },
  '瑪格麗特': { zhtw: '瑪格麗特', en: 'Daisy', },
  '黑薔薇': { zhtw: '黑薔薇', en: 'Black Rose', },
  '富貴菊': { zhtw: '富貴菊', en: 'Cineraria', },
  '報春花': { zhtw: '報春花', en: 'Primrose', },
  '秋海棠': { zhtw: '秋海棠', en: 'Begonia', },
  '風鈴草': { zhtw: '風鈴草', en: 'Campanula', },
  '聖誕玫瑰': { zhtw: '聖誕玫瑰', en: 'Hellebore', },
  '小麥': { zhtw: '小麥', en: 'Wheat', },
  '茶葉': { zhtw: '茶葉', en: 'Tea Leaves', },
  '乾草飼料': { zhtw: '乾草飼料', en: 'Fodder', },
  '香菇種菌': { zhtw: '香菇種菌', en: 'Shiitake Spores', },
  '鴻喜菇種菌': { zhtw: '鴻喜菇種菌', en: 'Shimeji Spores', },
  '杏鮑菇種菌': { zhtw: '杏鮑菇種菌', en: 'Trumpet Spores', },
  '粉紅珊瑚菇種菌': { zhtw: '粉紅珊瑚菇種菌', en: 'Coral Spores', },
  '洋菇種菌': { zhtw: '洋菇種菌', en: 'Common Spores', },
  '松茸種菌': { zhtw: '松茸種菌', en: 'Matsutake Spores', },
  '草莓類': { zhtw: '草莓類', en: 'Strawberry Group', },
  '蜂蜜巢蜜': { zhtw:'蜂蜜巢蜜', en:'Honey Hive', },
  '蜂巢巢蜜': { zhtw:'蜂巢巢蜜', en:'Honeycomb Hive', },
  '工蜂巢蜜': { zhtw:'工蜂巢蜜', en:'Worker Hive', },
  '蜂王巢蜜': { zhtw:'蜂王巢蜜', en:'Royal Hive', },
  '蜂蜜': { zhtw:'蜂蜜', en:'Honey', },
  '蜂蜜類': { zhtw:'蜂蜜類', en:'Honey Group', },
  '蜂巢蜜': { zhtw:'蜂巢蜜', en:'Comb Honey', },
  '工蜂乳': { zhtw:'工蜂乳', en:'Worker Jelly', },
  '蜂王乳': { zhtw:'蜂王乳', en:'Royal Jelly', },
  '石塊': {zhtw:'石塊', en:'Stone'},
  '鐵礦石': {zhtw:'鐵礦石', en:'Iron Ore'},
  '銀礦石': {zhtw:'銀礦石', en:'Silver Ore'},
  '金礦石': {zhtw:'金礦石', en:'Gold Ore'},
  '奧利哈鋼礦石': {zhtw:'奧利哈鋼礦石', en:'Orichalcum Ore'},
  '玻璃石': {zhtw:'玻璃石', en:'Glass Rock'},
  '石炭塊': {zhtw:'石炭塊', en:'Coal Lump'},
  '白色蛋白石原石': {zhtw:'白色蛋白石原石', en:'Raw White Opal'},
  '紅綠柱石原石': {zhtw:'紅綠柱石原石', en:'Raw Red Beryl'},
  '紅寶石原石': {zhtw:'紅寶石原石', en:'Raw Ruby'},
  '藍寶石原石': {zhtw:'藍寶石原石', en:'Raw Sapphire'},
  '祖母綠原石': {zhtw:'祖母綠原石', en:'Raw Emerald'},
  '鑽石原石': {zhtw:'鑽石原石', en:'Raw Diamond'},

  '鐵塊': {zhtw:'鐵塊', en:'Iron Ingot'},
  '銀塊': {zhtw:'銀塊', en:'Silver Ingot'},
  '金塊': {zhtw:'金塊', en:'Gold Ingot'},
  '奧利哈鋼金屬塊': {zhtw:'奧利哈鋼金屬塊', en:'Orichalcum Ingot'},
  '煤炭': {zhtw:'煤炭', en:'Refined Coal'},
  '玻璃': {zhtw:'玻璃', en:'Glass'},

  '白色蛋白石': {zhtw:'白色蛋白石', en:'White Opal'},
  '紅綠柱石': {zhtw:'紅綠柱石', en:'Red Beryl'},
  '紅寶石': {zhtw:'紅寶石', en:'Ruby'},
  '藍寶石': {zhtw:'藍寶石', en:'Sapphire'},
  '祖母綠': {zhtw:'祖母綠', en:'Emerald'},
  '鑽石': {zhtw:'鑽石', en:'Diamond'},
  '春風進行曲': {zhtw:'春風進行曲', en:'Springtime March'},
  '炎帝華爾滋': {zhtw:'炎帝華爾滋', en:'Blazing Waltz'},
  '月夜夜曲': {zhtw:'月夜夜曲', en:'Moonlight Nocturne'},
  '雪花輪舞曲': {zhtw:'雪花輪舞曲', en:'Winter Bloom Rondo'},
  '大地協奏曲': {zhtw:'大地協奏曲', en:'Earth Concerto'},
  '彩虹花束': {zhtw:'彩虹花束', en:'Rainbow Bouquet'},
  '珠寶戒指': {zhtw:'珠寶戒指', en:'Jewelry Ring'},
  '珠寶墜子': {zhtw:'珠寶墜子', en:'Jewelry Locket'},
  '時髦手環': {zhtw:'時髦手環', en:'Fashionable Bracelet'},
  '發光手錶': {zhtw:'發光手錶', en:'Shiny Watch'},

  '木材加工機': { zhtw: '木材加工機', en: 'Lumber Maker'},
  '巨大木材加工機': { zhtw: '巨大木材加工機', en: 'Giant Lumber Maker'},
  '絲線加工機': { zhtw: '絲線加工機', en: 'Thread Maker'},
  '巨大絲線加工機': { zhtw: '巨大絲線加工機', en: 'Giant Thread Maker'},
  '布料加工機': { zhtw: '布料加工機', en: 'Textile Maker'},
  '巨大布料加工機': { zhtw: '巨大布料加工機', en: 'Giant Textile Maker'},
  '金屬塊加工機': { zhtw: '金屬塊加工機', en: 'Ingot Maker'},
  '巨大金屬塊加工機': { zhtw: '巨大金屬塊加工機', en: 'Giant Ingot Maker'},
  '珠寶加工機': { zhtw: '珠寶加工機', en: 'Jewel Maker'},
  '巨大珠寶加工機': { zhtw: '巨大珠寶加工機', en: 'Giant Jewel Maker'},
  '磚頭加工機': { zhtw: '磚頭加工機', en: 'Brick Maker'},
  '巨大磚頭加工機': { zhtw: '巨大磚頭加工機', en: 'Giant Brick Maker'},
  '農作物種子加工機': { zhtw: '農作物種子加工機', en: 'Seed Maker'},
  '巨大農作物種子加工機': { zhtw: '巨大農作物種子加工機', en: 'Giant Seed Maker'},
  '粉末加工機': { zhtw: '粉末加工機', en: 'Powder Maker'},
  '巨大粉末加工機': { zhtw: '巨大粉末加工機', en: 'Giant Powder Maker'},
  '幼苗加工機': { zhtw: '幼苗加工機', en: 'Seedling Maker'},
  '巨大幼苗加工機': { zhtw: '巨大幼苗加工機', en: 'Giant Seedling Maker'},
  '果醬加工機': { zhtw: '果醬加工機', en: 'Jam Maker'},
  '巨大果醬加工機': { zhtw: '巨大果醬加工機', en: 'Giant Jam Maker'},
  '菇類種菌加工機': { zhtw: '菇類種菌加工機', en: 'Spore Maker'},
  '巨大菇類種菌加工機': { zhtw: '巨大菇類種菌加工機', en: 'Giant Spore Maker'},
  '蜂蜜加工機': { zhtw: '蜂蜜加工機', en: 'Honey Maker'},
  '巨大蜂蜜加工機': { zhtw: '巨大蜂蜜加工機', en: 'Giant Honey Maker'},
  '毛線加工機': { zhtw: '毛線加工機', en: 'Yarn Maker'},
  '巨大毛線加工機': { zhtw: '巨大毛線加工機', en: 'Giant Yarn Maker'},
  '毛料加工機': { zhtw: '毛料加工機', en: 'Cloth Maker'},
  '巨大毛料加工機': { zhtw: '巨大毛料加工機', en: 'Giant Cloth Maker'},
  '起司加工機': { zhtw: '起司加工機', en: 'Cheese Maker'},
  '巨大起司加工機': { zhtw: '巨大起司加工機', en: 'Giant Cheese Maker'},
  '奶油加工機': { zhtw: '奶油加工機', en: 'Butter Maker'},
  '巨大奶油加工機': { zhtw: '巨大奶油加工機', en: 'Giant Butter Maker'},
  '優格加工機': { zhtw: '優格加工機', en: 'Yogurt Maker'},
  '巨大優格加工機': { zhtw: '巨大優格加工機', en: 'Giant Yogurt Maker'},
  '美乃滋加工機': { zhtw: '美乃滋加工機', en: 'Mayonnaise Maker'},
  '巨大美乃滋加工機': { zhtw: '巨大美乃滋加工機', en: 'Giant Mayonnaise Maker'},
  '調味料加工機': { zhtw: '調味料加工機', en: 'Seasoning Maker'},
  '巨大調味料加工機': { zhtw: '巨大調味料加工機', en: 'Giant Seasoning Maker'},
  '液體調味料加工機': { zhtw: '液體調味料加工機', en: 'Condiment Maker'},
  '巨大液體調味料加工機': { zhtw: '巨大液體調味料加工機', en: 'Giant Condiment Maker'},
  '香精加工機': { zhtw: '香精加工機', en: 'Essence Maker'},
  '巨大香精加工機': { zhtw: '巨大香精加工機', en: 'Giant Essence Maker'},
  '染料加工機': { zhtw: '染料加工機', en: 'Dye Maker'},
  '巨大染料加工機': { zhtw: '巨大染料加工機', en: 'Giant Dye Maker'},

  '草莓果醬': {zhtw:'草莓果醬', en:'Strawberry Jam'},
  '櫻桃果醬': {zhtw:'櫻桃果醬', en:'Cherry Jam'},
  '柳橙果醬': {zhtw:'柳橙果醬', en:'Orange Marmalade'},
  '西瓜果醬': {zhtw:'西瓜果醬', en:'Watermelon Jam'},
  '哈密瓜果醬': {zhtw:'哈密瓜果醬', en:'Melon Jam'},
  '鳳梨果醬': {zhtw:'鳳梨果醬', en:'Pineapple Jam'},
  '檸檬果醬': {zhtw:'檸檬果醬', en:'Lemon Jam'},
  '芒果果醬': {zhtw:'芒果果醬', en:'Mango Jam'},
  '椰子果醬': {zhtw:'椰子果醬', en:'Coconut Jam'},
  '香蕉果醬': {zhtw:'香蕉果醬', en:'Banana Jam'},
  '桃子果醬': {zhtw:'桃子果醬', en:'Peach Jam'},
  '蘋果果醬': {zhtw:'蘋果果醬', en:'Apple Jam'},
  '葡萄果醬': {zhtw:'葡萄果醬', en:'Grape Jam'},

  '原木': {zhtw:'原木', en:'Log'},
  '堅硬的原木': {zhtw:'堅硬的原木', en:'Solid Log'},
  '柔韌的原木': {zhtw:'柔韌的原木', en:'Supple Log'},
  '粗壯的原木': {zhtw:'粗壯的原木', en:'Durable Log'},
  '夢幻原木': {zhtw:'夢幻原木', en:'Mirage Log'},
  '樹汁': {zhtw:'樹汁', en:'Sap'},

  '木材': {zhtw:'木材', en:'Lumber'},
  '堅硬的木材': {zhtw:'堅硬的木材', en:'Solid Lumber'},
  '柔韌的木材': {zhtw:'柔韌的木材', en:'Supple Lumber'},
  '粗壯的木材': {zhtw:'粗壯的木材', en:'Durable Lumber'},
  '夢幻木材': {zhtw:'夢幻木材', en:'Mirage Lumber'},
  '木炭': {zhtw:'木炭', en:'Wood Charcoal'},

  '草': {zhtw:'草', en:'Grass'},
  '柔軟的草': {zhtw:'柔軟的草', en:'Flexible Grass'},
  '堅韌的草': {zhtw:'堅韌的草', en:'Tough Grass'},
  '觸感柔滑的草': {zhtw:'觸感柔滑的草', en:'Smooth Grass'},
  '夢幻草': {zhtw:'夢幻草', en:'Mirage Grass'},

  '野莓': {zhtw:'野莓', en:'Wild Berry'},
  '紫萁': {zhtw:'紫萁', en:'Royal Fern'},
  '款冬': {zhtw:'款冬', en:'Butterbur'},
  '筆頭菜': {zhtw:'筆頭菜', en:'Horsetail'},
  '栗子': {zhtw:'栗子', en:'Chestnut'},
  '竹筍': {zhtw:'竹筍', en:'Bamboo Shoot'},

  '奧勒岡葉': {zhtw:'奧勒岡葉', en:'Oregano'},
  '鼠尾草': {zhtw:'鼠尾草', en:'Sage'},
  '芳香萬壽菊': {zhtw:'芳香萬壽菊', en:'Lemon Marigold'},
  '金雨迷迭香': {zhtw:'金雨迷迭香', en:'Golden Rain Rosemary'},

  '月落草': {zhtw:'月落草', en:'Moondrop Flower'},
  '粉色貓薄荷': {zhtw:'粉色貓薄荷', en:'Pink Cat Flower'},
  '魔法藍草': {zhtw:'魔法藍草', en:'Magic Blue Flower'},
  '魔法紅草': {zhtw:'魔法紅草', en:'Magic Red Flower'},

  '閃電熔結岩': {zhtw:'閃電熔結岩', en:'Fulgurite'},
  '水砷鐵銅石': {zhtw:'水砷鐵銅石', en:'Arthurite'},
  '沙漠玫瑰': {zhtw:'沙漠玫瑰', en:'Desert Rose'},
  '兔尾石': {zhtw:'兔尾石', en:'Okenite'},
  '吉丙隕石': {zhtw:'吉丙隕石', en:'Gibeon Stone'},
  '橄欖隕鐵': {zhtw:'橄欖隕鐵', en:'Parasite Stone'},
  '龍涎香': {zhtw:'龍涎香', en:'Ambergris'},
  '洞穴珍珠': {zhtw:'洞穴珍珠', en:'Cave Pearl'},
  '琥珀結晶': {zhtw:'琥珀結晶', en:'Crystallized Amber'},
  '橄欖結晶': {zhtw:'橄欖結晶', en:'Olive Crystal'},
  '古代飾品': {zhtw:'古代飾品', en:'Antique Accessory'},
  '古代鏡子': {zhtw:'古代鏡子', en:'Antique Mirror'},
  '古代擺飾': {zhtw:'古代擺飾', en:'Antique Decoration'},
  '古代石碑': {zhtw:'古代石碑', en:'Antique Monument'},
  '老舊的硬幣': {zhtw:'老舊的硬幣', en:'Timeworn Coin'},
  '老舊的團扇': {zhtw:'老舊的團扇', en:'Timeworn Fan'},
  '老舊的卷軸': {zhtw:'老舊的卷軸', en:'Timeworn Scroll'},
  '老舊的羅盤': {zhtw:'老舊的羅盤', en:'Timeworn Compass'},
  '老舊的地圖': {zhtw:'老舊的地圖', en:'Timeworn Map'},
  '閃亮的馬刺': {zhtw:'閃亮的馬刺', en:'Sparkling Spur'},
  '閃亮的冠軍皮帶扣': {zhtw:'閃亮的冠軍皮帶扣', en:'Shiny Trophy Buckle'},
  '黃金牛角頭盔': {zhtw:'黃金牛角頭盔', en:'Cow Helm'},
  '黃金號角': {zhtw:'黃金號角', en:'Golden Horn'},
  '黑色古文書': {zhtw:'黑色古文書', en:'Ancient Black Tome'},
  '白色古文書': {zhtw:'白色古文書', en:'Ancient White Tome'},
  '玻璃鞋': {zhtw:'玻璃鞋', en:'Glass Slipper'},
  '古老的齒輪': {zhtw:'古老的齒輪', en:'Prehistoric Gear'},
  '古代貝類化石': {zhtw:'古代貝類化石', en:'Ancient Shell Fossil'},
  '古代節肢動物化石': {zhtw:'古代節肢動物化石', en:'Ancient Bug Fossil'},
  '恐龍化石': {zhtw:'恐龍化石', en:'Dinosaur Fossil'},

  '紅色染料': { zhtw :'紅色染料', en: 'Red Dye' },
  '藍色染料': { zhtw :'藍色染料', en: 'Blue Dye' },
  '綠色染料': { zhtw :'綠色染料', en: 'Green Dye' },
  '黃色染料': { zhtw :'黃色染料', en: 'Yellow Dye' },
  '紫色染料': { zhtw :'紫色染料', en: 'Purple Dye' },
  '桃色染料': { zhtw :'桃色染料', en: 'Pink Dye' },
  '白色染料': { zhtw :'白色染料', en: 'White Dye' },
  '黑色染料': { zhtw :'黑色染料', en: 'Black Dye' },

  '小型魚類釣餌': {zhtw:'小型魚類釣餌', en:'Small Fish Bait'},
  '中型魚類釣餌': {zhtw:'中型魚類釣餌', en:'Medium Fish Bait'},
  '大型魚類釣餌': {zhtw:'大型魚類釣餌', en:'Large Fish Bait'},
  '烏賊類釣餌': {zhtw:'烏賊類釣餌', en:'Squid Bait'},
  '蝦類釣餌': {zhtw:'蝦類釣餌', en:'Shrimp Bait'},
  '蟹類釣餌': {zhtw:'蟹類釣餌', en:'Crab Bait'},
  '水中霸主釣餌': {zhtw:'水中霸主釣餌', en:'Guardian Bait'},
  '奇妙的釣餌': {zhtw:'奇妙的釣餌', en:'Mysterious Bait'},

  '羊毛': {zhtw:'羊毛', en:'Wool'},
  '頂級羊毛': {zhtw:'頂級羊毛', en:'Wool +'},
  '薩福克羊毛': {zhtw:'薩福克羊毛', en:'Suffolk Wool'},
  '頂級薩福克羊毛': {zhtw:'頂級薩福克羊毛', en:'Suffolk Wool +'},
  '羊駝毛': {zhtw:'羊駝毛', en:'Alpaca Wool'},
  '頂級羊駝毛': {zhtw:'頂級羊駝毛', en:'Alpaca Wool +'},
  '茶色羊駝毛': {zhtw:'茶色羊駝毛', en:'Brown Alpaca Wool'},
  '頂級茶色羊駝毛': {zhtw:'頂級茶色羊駝毛', en:'Brown Alpaca Wool +'},
  '兔毛': {zhtw:'兔毛', en:'Rabbit Fur'},
  '頂級兔毛': {zhtw:'頂級兔毛', en:'Rabbit Fur +'},
  '灰色兔毛': {zhtw:'灰色兔毛', en:'Gray Rabbit Fur'},
  '頂級灰色兔毛': {zhtw:'頂級灰色兔毛', en:'Gray Rabbit Fur +'},
  '桃色兔毛': {zhtw:'桃色兔毛', en:'Pink Rabbit Fur'},
  '頂級桃色兔毛': {zhtw:'頂級桃色兔毛', en:'Pink Rabbit Fur +'},

  '繩子': {zhtw:'繩子', en:'Twine'},
  '絲線': {zhtw:'絲線', en:'Thread'},
  '柔軟的絲線': {zhtw:'柔軟的絲線', en:'Flexible Thread'},
  '堅韌的絲線': {zhtw:'堅韌的絲線', en:'Tough Thread'},
  '觸感柔滑的絲線': {zhtw:'觸感柔滑的絲線', en:'Smooth Thread'},
  '夢幻絲線': {zhtw:'夢幻絲線', en:'Mirage Thread'},
  '羊毛線': {zhtw:'羊毛線', en:'Woolen Yarn'},
  '薩福克羊毛線': {zhtw:'薩福克羊毛線', en:'Suffolk Yarn'},
  '羊駝毛線': {zhtw:'羊駝毛線', en:'Alpaca Yarn'},
  '茶色羊駝毛線': {zhtw:'茶色羊駝毛線', en:'Brown Alpaca Yarn'},
  '兔毛線': {zhtw:'兔毛線', en:'Rabbit Yarn'},
  '灰色兔毛線': {zhtw:'灰色兔毛線', en:'Gray Rabbit Yarn'},
  '桃色兔毛線': {zhtw:'桃色兔毛線', en:'Pink Rabbit Yarn'},

  '布': {zhtw:'布', en:'Cloth'},
  '柔軟的布料': {zhtw:'柔軟的布料', en:'Flexible Cloth'},
  '堅韌的布料': {zhtw:'堅韌的布料', en:'Tough Cloth'},
  '觸感柔滑的布料': {zhtw:'觸感柔滑的布料', en:'Smooth Cloth'},
  '夢幻布料': {zhtw:'夢幻布料', en:'Mirage Cloth'},
  '羊毛毛料': {zhtw:'羊毛毛料', en:'Woolen Cloth'},
  '薩福克羊毛毛料': {zhtw:'薩福克羊毛毛料', en:'Suffolk Cloth'},
  '羊駝毛毛料': {zhtw:'羊駝毛毛料', en:'Alpaca Cloth'},
  '茶色羊駝毛毛料': {zhtw:'茶色羊駝毛毛料', en:'Brown Alpaca Cloth'},
  '兔毛毛料': {zhtw:'兔毛毛料', en:'Rabbit Cloth'},
  '灰色兔毛毛料': {zhtw:'灰色兔毛毛料', en:'Gray Rabbit Cloth'},
  '桃色兔毛毛料': {zhtw:'桃色兔毛毛料', en:'Pink Rabbit Cloth'},

  '岩鹽': {zhtw:'岩鹽', en:'Rock Salt'},
  '胡椒果實': {zhtw:'胡椒果實', en:'Peppercorn'},
  '甘蔗': {zhtw:'甘蔗', en:'Sugarcane'},
  '鹽': {zhtw:'鹽', en:'Salt'},
  '胡椒': {zhtw:'胡椒', en:'Pepper'},
  '砂糖': {zhtw:'砂糖', en:'Sugar'},
  '醬油': {zhtw:'醬油', en:'Soy Sauce'},
  '醋': {zhtw:'醋', en:'Vinegar'},
  '橄欖油': {zhtw:'橄欖油', en:'Olive Oil'},
  '香草調味料': {zhtw:'香草調味料', en:'Mixed Herbs'},
  '辛辣調味料': {zhtw:'辛辣調味料', en:'Mixed Spices'},
  '咖啡粉': {zhtw:'咖啡粉', en:'Coffee Powder'},
  '可可粉': {zhtw:'可可粉', en:'Cocoa Powder'},
  '麵粉': {zhtw:'麵粉', en:'Flour'},
  '奶油': {zhtw:'奶油', en:'Butter'},
  '起司': {zhtw:'起司', en:'Cheese'},
  '美乃滋': {zhtw:'美乃滋', en:'Mayonnaise'},
  '優格': {zhtw:'優格', en:'Yogurt'},

  'way': { zhtw: '取得方式', en: 'Way'},
  '菇': { zhtw: '菇', en: 'Mushroom'},
  '種菌': { zhtw: '種菌', en: 'Spore'},
  '木頭': { zhtw: '原木', en: 'Wood'},
  '石頭': { zhtw: '石頭', en: 'Stone'},
  '山菜': { zhtw: '山菜', en: 'Wild Plant'},
  '香草': { zhtw: '香草', en: 'Herb'},
  '寶石': { zhtw: '寶石', en: 'Jewel'},
  '調味料': { zhtw: '調味料', en: 'Seasoning'},
  '加工機': { zhtw: '加工機', en: 'Maker'},
  '花束': { zhtw: '花束', en: 'Bouquet'},
  '飾品': { zhtw: '飾品', en: 'Accessory'},
  '香精': { zhtw: '香精', en: 'Essence'},
  '香水': { zhtw: '香水', en: 'Perfume'},
  '果醬': { zhtw: '果醬', en: 'Jam'},
  '寶物': { zhtw: '寶物', en: 'Treasure'},
  '寶物仿製品': { zhtw: '寶物仿製品', en: 'Faux Treasure'},
  '動物雕像': { zhtw: '動物雕像', en: 'Animal Statue'},
  '染料': { zhtw: '染料', en: 'Dye'},
  '金屬塊': { zhtw: '金屬塊', en: 'Ingot'},
  '釣餌': { zhtw: '釣餌', en: 'Bait'},
  '線': { zhtw: '線', en: 'Thread'},
  '毛': { zhtw: '毛', en: 'Animal Wool/Fur'},
  '寵物用品': { zhtw: '寵物用品', en: 'Pet Supplies'},
  '家具': { zhtw: '家具', en: 'Furniture'},
  '布料': {zhtw:'布料', en:'Cloth'},
  '開拓': {zhtw:'開拓', en:'Pioneering'},
  '釣魚': {zhtw:'釣魚', en:'Fishing'},

  '葛洛莉雅': { zhtw: '葛洛莉雅', en: 'Gloria' },
  '鎮長太太': { zhtw: '鎮長太太', en: 'Mayor Wife' },
  '博物館': { zhtw: '博物館', en: 'Museum' },
  '貝絲': { zhtw: '貝絲', en: 'Beth' },
  '紅毛雙馬尾眼鏡娘': { zhtw: '紅毛雙馬尾眼鏡娘', en: 'Red-haired, double ponytails, glasses' },
  '咖啡廳': { zhtw: '咖啡廳', en: 'Café' },
  '蕾娜': { zhtw: '蕾娜', en: 'Reina' },
  '伊織': { zhtw: '伊織', en: 'Iori' },
  '日本武士': { zhtw: '日本武士', en: 'Japanese Warrior' },
  '清心庵': { zhtw: '清心庵', en: 'Seishin-an' },
  '席妮': { zhtw: '席妮', en: 'Sydney' },
  '女強人': { zhtw: '女強人', en: 'Businesswoman' },
  '拉夫': { zhtw: '拉夫', en: 'Ralph' },
  '巡林員': { zhtw: '巡林員', en: 'Ranger' },
  '木工店': { zhtw: '木工店', en: 'Handiworks' },
  '小琳': { zhtw: '小琳', en: 'Linh' },
  '花店': { zhtw: '花店', en: 'Flower Shop' },
  '傑克': { zhtw: '傑克', en: 'Jack' },
  '雜貨店': { zhtw: '雜貨店', en: 'General Store' },
  '雜貨店兒子': { zhtw: '雜貨店兒子', en: 'Son Of General Store' },
  '布萊兒': { zhtw: '布萊兒', en: 'Blaire' },
  '金髮女孩': { zhtw: '金髮女孩', en: 'Blonde Girl' },
  '道節': { zhtw: '道節', en: 'Dosetsu' },
  '少主侍從': { zhtw: '少主侍從', en: "Iori's attendant" },
  '最喜番': { zhtw: '最喜番', en: "Lovett" },
  '孤獨的美食家': { zhtw: '孤獨的美食家', en: "Food Critic" },
  '莎莉': { zhtw: '莎莉', en: "Sally" },
  '咖啡廳金髮貴婦': { zhtw: '咖啡廳金髮貴婦', en: "Café Blonde Lady" },
  '卡琳娜': { zhtw: '卡琳娜', en: "Karina" },
  '黑皮設計師': { zhtw: '黑皮設計師', en: "Stylist" },
  '沙龍': { zhtw: '沙龍', en: "Salon" },
  '琴': { zhtw: '琴', en: "Jeanne" },
  '白色短髮美容師': { zhtw: '白色短髮美容師', en: "White Hair Esthetician" },
  '諾曼': { zhtw: '諾曼', en: "Norman" },
  '地中海禿': { zhtw: '地中海禿', en: "Baldness" },
  '食材店': { zhtw: '食材店', en: "Groceries" },
  '潔西': { zhtw: '潔西', en: "Jessie" },
  '老婆婆': { zhtw: '老婆婆', en: "Granny" },
  '戴蒙': { zhtw: '戴蒙', en: "Damon" },
  '馬可斯': { zhtw: '馬可斯', en: "Marcos" },
  '漁夫': { zhtw: '漁夫', en: "Fisherman" },
  '安琪拉': { zhtw: '安琪拉', en: "Angela" },
  '派翠西亞': { zhtw: '派翠西亞', en: "Patricia" },
  '麥奇': { zhtw: '麥奇', en: "Mikey" },
  '小胖子': { zhtw: '小胖子', en: "Chubby Boy" },
  '關': { zhtw: '關', en: "Nguyen" },
  '花店爺爺': { zhtw: '花店爺爺', en: "Flower Shop Grandpa" },
  '奈吉爾': { zhtw: '奈吉爾', en: "Nigel" },
  '木匠': { zhtw: '木匠', en: "Carpenter" },
  '傑森': { zhtw: '傑森', en: "Jason" },
  '旅館老闆': { zhtw: '旅館老闆', en: "Hotel Owner" },
  '克萊門斯': { zhtw: '克萊門斯', en: "Clemens" },
  '升級工具和背包': { zhtw: '升級工具和背包', en: "Bag & Tool Upgrades" },
  '工具行': { zhtw: '工具行', en: "Tool Shop" },
  '拉修': { zhtw: '拉修', en: "Lars" },
  '機車男': { zhtw: '機車男', en: "Motorcycle Boy" },
  '勞爾': { zhtw: '勞爾', en: "Raul" },
  '桃紅色T恤,武士頭': { zhtw: '桃紅色T恤,武士頭', en: "Samurai Hairstyle, Deep Pink T-shirt" },
  '美紗希': { zhtw: '美紗希', en: "Misaki" },
  '小餐館': { zhtw: '小餐館', en: "Bistro" },
  '布莉琪': { zhtw: '布莉琪', en: "Bridget" },
  '辛蒂': { zhtw: '辛蒂', en: "Cindy" },
  '小女孩': { zhtw: '小女孩', en: "Little Girl" },
  '曼紐拉': { zhtw: '曼紐拉', en: "Manuela" },
  '漁夫太太': { zhtw: '漁夫太太', en: "Fisherman Wife" },
  '菈菈': { zhtw: '菈菈', en: "Laura" },
  '觀光導遊': { zhtw: '觀光導遊', en: "Tour Guide" },
  '觀光': { zhtw: '菈菈', en: "Tourist" }, // Tourist Information Center
  '漁夫兒子,海灘風襯衫': { zhtw: '漁夫兒子,海灘風襯衫', en: "Fisherman Son, Beach Shirt" },



  '大熊木雕': { zhtw: '大熊木雕', en: 'Giant Bear Carving' },
  '筆記本 > 加工': { zhtw: '筆記本 > 加工', en: 'Notebook > Carving' },

  '閃電熔結岩的仿製品': {zhtw:'閃電熔結岩的仿製品', en:'Faux Fulgurite'},
  '水砷鐵銅石的仿製品': {zhtw:'水砷鐵銅石的仿製品', en:'Faux Arthurite'},
  '沙漠玫瑰的仿製品': {zhtw:'沙漠玫瑰的仿製品', en:'Faux Desert Rose'},
  '兔尾石的仿製品': {zhtw:'兔尾石的仿製品', en:'Faux Okenite'},
  '吉丙隕石的仿製品': {zhtw:'吉丙隕石的仿製品', en:'Faux Gibeon Stone'},
  '橄欖隕鐵的仿製品': {zhtw:'橄欖隕鐵的仿製品', en:'Faux Parasite Stone'},
  '龍涎香的仿製品': {zhtw:'龍涎香的仿製品', en:'Faux Ambergris'},
  '洞穴珍珠的仿製品': {zhtw:'洞穴珍珠的仿製品', en:'Faux Cave Pearl'},
  '琥珀結晶的仿製品': {zhtw:'琥珀結晶的仿製品', en:'Faux Crystallized Amber'},
  '橄欖結晶的仿製品': {zhtw:'橄欖結晶的仿製品', en:'Faux Olive Crystal'},
  '古代飾品的仿製品': {zhtw:'古代飾品的仿製品', en:'Faux Antique Accessory'},
  '古代鏡子的仿製品': {zhtw:'古代鏡子的仿製品', en:'Faux Antique Mirror'},
  '古代擺飾的仿製品': {zhtw:'古代擺飾的仿製品', en:'Faux Antique Decoration'},
  '古代石碑的仿製品': {zhtw:'古代石碑的仿製品', en:'Faux Antique Monument'},
  '老舊的硬幣的仿製品': {zhtw:'老舊的硬幣的仿製品', en:'Faux Timeworn Coin'},
  '老舊的團扇的仿製品': {zhtw:'老舊的團扇的仿製品', en:'Faux Timeworn Fan'},
  '老舊的卷軸的仿製品': {zhtw:'老舊的卷軸的仿製品', en:'Faux Timeworn Scroll'},
  '老舊的羅盤的仿製品': {zhtw:'老舊的羅盤的仿製品', en:'Faux Timeworn Compass'},
  '老舊的地圖的仿製品': {zhtw:'老舊的地圖的仿製品', en:'Faux Timeworn Map'},
  '閃亮的馬刺的仿製品': {zhtw:'閃亮的馬刺的仿製品', en:'Faux Sparkling Spur'},
  '閃亮的冠軍皮帶扣的仿製品': {zhtw:'閃亮的冠軍皮帶扣的仿製品', en:'Faux Shiny Trophy Buckle'},
  '黃金牛角頭盔的仿製品': {zhtw:'黃金牛角頭盔的仿製品', en:'Faux Cow Helm'},
  '黃金號角的仿製品': {zhtw:'黃金號角的仿製品', en:'Faux Golden Horn'},
  '黑色古文書的仿製品': {zhtw:'黑色古文書的仿製品', en:'Faux Ancient Black Tome'},
  '白色古文書的仿製品': {zhtw:'白色古文書的仿製品', en:'Faux Ancient White Tome'},
  '玻璃鞋的仿製品': {zhtw:'玻璃鞋的仿製品', en:'Faux Glass Slipper'},
  '古老的齒輪的仿製品': {zhtw:'古老的齒輪的仿製品', en:'Faux Prehistoric Gear'},
  '古代貝類化石的仿製品': {zhtw:'古代貝類化石的仿製品', en:'Faux Ancient Shell Fossil'},
  '古代節肢動物化石的仿製品': {zhtw:'古代節肢動物化石的仿製品', en:'Faux Ancient Bug Fossil'},
  '恐龍化石的仿製品': {zhtw:'恐龍化石的仿製品', en:'Faux Dinosaur Fossil'},

  '捕魚網': {zhtw:'捕魚網', en:'Net'},
  '萬能捕魚網': {zhtw:'萬能捕魚網', en:'Multipurpose Net'},
  '巨大捕魚網': {zhtw:'巨大捕魚網', en:'Giant Net'},

  '寵物零食': {zhtw:'寵物零食', en:'Pet Treat'},
  '高級寵物零食': {zhtw:'高級寵物零食', en:'Fancy Pet Treat'},
  '軟軟球': {zhtw:'軟軟球', en:'Bouncy Ball'},
  '老鼠球': {zhtw:'老鼠球', en:'Mouse Ball'},

  '松鼠': {zhtw:'松鼠', en:'Squirrel'},
  '黃色狐狸': {zhtw:'黃色狐狸', en:'Orange Fox'},
  '白色狐狸': {zhtw:'白色狐狸', en:'White Fox'},
  '茶色白鼬': {zhtw:'茶色白鼬', en:'Brown Ermine'},
  '白色白鼬': {zhtw:'白色白鼬', en:'White Ermine'},
  '熊': {zhtw:'熊', en:'Bear'},
  '猴子': {zhtw:'猴子', en:'Monkey'},
  '麻雀': {zhtw:'麻雀', en:'Sparrow'},
  '貓頭鷹': {zhtw:'貓頭鷹', en:'Owl'},
  '青鳥': {zhtw:'青鳥', en:'Bluebird'},
  '岩雷鳥': {zhtw:'岩雷鳥', en:'Ptarmigan'},
  '老鷹': {zhtw:'老鷹', en:'Eagle'},
  '游隼': {zhtw:'游隼', en:'Falcon'},
  '日本獨角仙': {zhtw:'日本獨角仙', en:'Rhinoceros Beetle'},
  '大鍬形蟲': {zhtw:'大鍬形蟲', en:'Stag Beetle'},
  '長戢獨角仙': {zhtw:'長戢獨角仙', en:'Hercules Beetle'},
  '紋白蝶': {zhtw:'紋白蝶', en:'White Butterfly'},
  '鳳蝶': {zhtw:'鳳蝶', en:'Swallowtail'},
  '大藍閃蝶': {zhtw:'大藍閃蝶', en:'Morpho'},
  '球馬陸': {zhtw:'球馬陸', en:'G.P. Millipede'},
  '松鼠雕像': {zhtw:'松鼠雕像', en:'Squirrel Statue'},
  '黃色狐狸雕像': {zhtw:'黃色狐狸雕像', en:'Orange Fox Statue'},
  '白色狐狸雕像': {zhtw:'白色狐狸雕像', en:'White Fox Statue'},
  '茶色白鼬雕像': {zhtw:'茶色白鼬雕像', en:'Brown Ermine Statue'},
  '白色白鼬雕像': {zhtw:'白色白鼬雕像', en:'White Ermine Statue'},
  '熊雕像': {zhtw:'熊雕像', en:'Bear Statue'},
  '猴子雕像': {zhtw:'猴子雕像', en:'Monkey Statue'},
  '麻雀雕像': {zhtw:'麻雀雕像', en:'Sparrow Statue'},
  '貓頭鷹雕像': {zhtw:'貓頭鷹雕像', en:'Owl Statue'},
  '青鳥雕像': {zhtw:'青鳥雕像', en:'Bluebird Statue'},
  '岩雷鳥雕像': {zhtw:'岩雷鳥雕像', en:'Ptarmigan Statue'},
  '老鷹雕像': {zhtw:'老鷹雕像', en:'Eagle Statue'},
  '游隼雕像': {zhtw:'游隼雕像', en:'Falcon Statue'},
  '日本獨角仙雕像': {zhtw:'日本獨角仙雕像', en:'Rhinoceros Beetle Statue'},
  '大鍬形蟲雕像': {zhtw:'大鍬形蟲雕像', en:'Hercules Beetle Statue'},
  '長戢獨角仙雕像': {zhtw:'長戢獨角仙雕像', en:'Stag Beetle Statue'},
  '紋白蝶雕像': {zhtw:'紋白蝶雕像', en:'White Butterfly Statue'},
  '鳳蝶雕像': {zhtw:'鳳蝶雕像', en:'Swallowtail Statue'},
  '大藍閃蝶雕像': {zhtw:'大藍閃蝶雕像', en:'Morpho Statue'},
  '螃蟹雕像': {zhtw:'螃蟹雕像', en:'Crab Statue'},
  '球馬陸雕像': {zhtw:'球馬陸雕像', en:'G.P. Millipede Statue'},

  '白色天堂鳥': {zhtw:'白色天堂鳥', en:'Bird of Paradise Plant'},
  '大果木棉': {zhtw:'大果木棉', en:'Money Tree'},
  '愛心榕': {zhtw:'愛心榕', en:'Ficus'},
  '花瓶': {zhtw:'花瓶', en:'Vase'},
  '單朵插花': {zhtw:'單朵插花', en:'Tiny Vase'},
  '細葉榕': {zhtw:'細葉榕', en:'Broadleaf Plant'},
  '盆栽': {zhtw:'盆栽', en:'Bonsai'},

  '高級座椅': {zhtw:'高級座椅', en:'Elegant Chair'},
  '高級沙發': {zhtw:'高級沙發', en:'Splendid Sofa'},
  '居家沙發': {zhtw:'居家沙發', en:'Comfy Sofa'},
  '大型桌子': {zhtw:'大型桌子', en:'Large Table'},
  '大型圓桌': {zhtw:'大型圓桌', en:'Large Round Table'},
  '書架': {zhtw:'書架', en:'Bookshelf'},
  '餐具櫃': {zhtw:'餐具櫃', en:'Cupboard'},
  '梳妝台': {zhtw:'梳妝台', en:'Vanity'},
  '方形紙罩座燈': {zhtw:'方形紙罩座燈', en:'Paper Lantern'},
  '屏風': {zhtw:'屏風', en:'Eastern Screen'},

  '穿衣鏡': {zhtw:'穿衣鏡', en:'Long Mirror'},
  '磚紋地毯': {zhtw:'磚紋地毯', en:'Tile Rug'},

  '沙丁魚': {zhtw:'沙丁魚', en:'Sardine'},
  '柳葉魚': {zhtw:'柳葉魚', en:'Shishamo Smelt'},
  '竹筴魚': {zhtw:'竹筴魚', en:'Horse Mackerel'},
  '珠星三塊魚': {zhtw:'珠星三塊魚', en:'Dace'},
  '鯡魚': {zhtw:'鯡魚', en:'Herring'},
  '鱈魚': {zhtw:'鱈魚', en:'Cod'},
  '鰻魚': {zhtw:'鰻魚', en:'Eel'},
  '花鱸': {zhtw:'花鱸', en:'Sea Bass'},
  '黃鱸': {zhtw:'黃鱸', en:'Yellow Perch'},
  '吳郭魚': {zhtw:'吳郭魚', en:'Tilapia'},
  '鯰魚': {zhtw:'鯰魚', en:'Catfish'},
  '烏鱧': {zhtw:'烏鱧', en:'Snakehead'},
  '白星笛鯛': {zhtw:'白星笛鯛', en:'Star Snapper'},
  '虱目魚': {zhtw:'虱目魚', en:'Milkfish'},
  '鯛魚': {zhtw:'鯛魚', en:'Sea Bream'},
  '比目魚': {zhtw:'比目魚', en:'Flounder'},
  '鮭魚': {zhtw:'鮭魚', en:'Salmon'},
  '鬼頭刀': {zhtw:'鬼頭刀', en:'Mahi-mahi'},
  '皇帶魚': {zhtw:'皇帶魚', en:'Oarfish'},
  '鮪魚': {zhtw:'鮪魚', en:'Tuna'},
  '大雀鱔': {zhtw:'大雀鱔', en:'Alligator Gar'},
  '安康魚': {zhtw:'安康魚', en:'Monkfish'},
  '湄公河巨鯰': {zhtw:'湄公河巨鯰', en:'Giant Catfish'},
  '螯蝦': {zhtw:'螯蝦', en:'Crayfish'},
  '鬚赤蝦': {zhtw:'鬚赤蝦', en:'Whiskered Velvet Shrimp'},
  '泰國蝦': {zhtw:'泰國蝦', en:'Giant Freshwater Prawn'},
  '草蝦': {zhtw:'草蝦', en:'Giant Tiger Shrimp'},
  '大龍蝦': {zhtw:'大龍蝦', en:'Lobster'},
  '伊勢龍蝦': {zhtw:'伊勢龍蝦', en:'Rock Lobster'},
  '三疣梭子蟹': {zhtw:'三疣梭子蟹', en:'Gazami Crab'},
  '藍蟹': {zhtw:'藍蟹', en:'Blue Crab'},
  '毛蟹': {zhtw:'毛蟹', en:'Horsehair Crab'},
  '松葉蟹': {zhtw:'松葉蟹', en:'Snow Crab'},
  '魷魚': {zhtw:'魷魚', en:'Common Squid'},
  '透抽': {zhtw:'透抽', en:'Spear Squid'},
  '軟絲': {zhtw:'軟絲', en:'Bigfin Reef Squid'},
  '墨魚': {zhtw:'墨魚', en:'Cuttlefish'},
  '赤貝': {zhtw:'赤貝', en:'Blood Clam'},
  '牡蠣': {zhtw:'牡蠣', en:'Oyster'},
  '淡菜': {zhtw:'淡菜', en:'Mussel'},
  '鮑魚': {zhtw:'鮑魚', en:'Abalone'},
  '雪花鴨嘴燕魟': {zhtw:'雪花鴨嘴燕魟', en:'Spotted Eagle Ray'},
  '扁鱈': {zhtw:'扁鱈', en:'Halibut'},
  '龍膽石斑': {zhtw:'龍膽石斑', en:'Giant Grouper'},
  '旗魚': {zhtw:'旗魚', en:'Marlin'},
  '大王烏賊': {zhtw:'大王烏賊', en:'Giant Squid'},
  '塔斯馬尼亞帝王蟹': {zhtw:'塔斯馬尼亞帝王蟹', en:'Giant King Crab'},
  '微光魚': {zhtw:'微光魚', en:'Sparkling Fish'},
  '發光魚': {zhtw:'發光魚', en:'Shining Fish'},
  '極光魚': {zhtw:'極光魚', en:'Aurora Fish'},

  'rod-table-header': {zhtw:'釣竿', en:'Rod'},
  'rod-mobile-table-content': {zhtw:'釣竿', en:' Rod'},
  'time': {zhtw:'時間', en:'Time'},
  'location': {zhtw:'地點', en:'Location'},
  '小積水': {zhtw:'小積水', en:'Puddle'},
  '池塘': {zhtw:'池塘', en:'Pond'},

  '小型魚': {zhtw:'小型魚', en:'Small Fish'},
  '中型魚': {zhtw:'中型魚', en:'Medium Fish'},
  '大型魚': {zhtw:'大型魚', en:'Large Fish'},
  '水中霸主': {zhtw:'水中霸主', en:'Guardian'},
  '稀有魚': {zhtw:'稀有魚', en:'Rare Fish'},
  '蝦子': {zhtw:'蝦子', en:'Shrimp'},
  '螃蟹': {zhtw:'螃蟹', en:'Crab'},
  '烏賊': {zhtw:'烏賊', en:'Squid'},
  '貝': {zhtw:'貝類', en:'Shellfish'},

  '基本': {zhtw:'基本', en:'Basic'},
  '鐵': {zhtw:'鐵', en:'Iron'},
  '銀': {zhtw:'銀', en:'Silver'},
  '金': {zhtw:'金', en:'Gold'},
  '奧利哈鋼': {zhtw:'奧利哈鋼', en:'Orichalcum'},

  '晴': {zhtw:'晴', en:'Sunny'},
  '雪': {zhtw:'雪', en:'Snow'},
  '暴風雪': {zhtw:'暴風雪', en:'Blizzard'},
  '雨': {zhtw:'雨', en:'Rain'},

  // '': { zhtw: '', en: '' },
  // '': { zhtw: '', en: '' },

  // '砂糖': {
  //   zhtw: '砂糖',
  //   en: 'Sugar',
  // },
  // '砂糖': {
  //   zhtw: '砂糖',
  //   en: 'Sugar',
  // },
  // '砂糖': {
  //   zhtw: '砂糖',
  //   en: 'Sugar',
  // },
  // '砂糖': {
  //   zhtw: '砂糖',
  //   en: 'Sugar',
  // },
}

// const REACT_APP_LANG = 'en';
// const REACT_APP_LANG = 'zhtw';
const REACT_APP_LANG = process.env.REACT_APP_LANG ? process.env.REACT_APP_LANG : 'zhtw';

const lang = (key) => {
  if(resourse[key]) {
    return resourse[key][REACT_APP_LANG] ? resourse[key][REACT_APP_LANG] : resourse[key]['zhtw'];
  }
  return key;
}

export const findZhtw = (en) => {
  let result;
  Object.values(resourse).forEach(r => {
    if (r.en === en) {
      result = r.zhtw;
      return;
    }
  })
  return result;
}

export default lang;

export function getLang() {
  return REACT_APP_LANG;
}